module.exports = __webpack_public_path__ + "img/img3.5341a22a.png";